import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import RouteName from "../../../routes/Route.name";
import history from "../../../libs/history.utils";
import LogUtils from "../../../libs/LogUtils";
import { actionFetchSideEffects, actionSetPageSideEffects } from "../../../actions/ReportedSideEffects.action";
import {serviceExportSideEffects} from "../../../services/ReportedSideEffects.service";
import {serviceGetList} from "../../../services/index.services";

const useReportedSideEffectsListHook = ({}) => {
  const [editData, setEditData] = useState(null);
  const [isSidePanel, setSidePanel] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [data, setData] = useState();
  const [listData, setListData] = useState({
    CLIENTS: [],
    PROGRAMS: [],
  });
  const dispatch = useDispatch();
  const isMountRef = useRef(false);

  const {
    sorting_data: sortingData,
    is_fetching: isFetching,
    query,
    query_data: queryData,
    all,
  } = useSelector((state) => state?.side_effects);

  useEffect(() => {
    serviceGetList([
      "CLIENTS", "PROGRAMS"
    ]).then((res) => {
      if (!res.error) {
        setListData(res.data);
      }
    });
  }, []);

  useEffect(() => { 
    dispatch(
      actionFetchSideEffects(
        1,
        {},
        {
          query: isMountRef.current ? query : null,
          query_data: isMountRef.current ? queryData : null,
        }
      )
    );
    isMountRef.current = true;
  }, []);

 
  const handlePageChange = useCallback((type) => {
    dispatch(actionSetPageSideEffects(type));
  }, []);

  const queryFilter = useCallback(
    (key, value) => {
      dispatch(
        actionFetchSideEffects(1, sortingData, {
          query: key == "SEARCH_TEXT" ? value : query,
          query_data: key == "FILTER_DATA" ? value : queryData,
        })
      );
    },
    [sortingData, query, queryData]
  );

  const handleFilterDataChange = useCallback(
    (value) => {
      const filteredValue = value?.map((item) =>
        item?.name === "is_general"
          ? { ...item, value: item?.value === "YES" }
          : item
      );
      queryFilter("FILTER_DATA", filteredValue);
    },
    [queryFilter]
  );

  const handleSearchValueChange = useCallback(
    (value) => {
      queryFilter("SEARCH_TEXT", value);
    },
    [queryFilter]
  );

  const handleSortOrderChange = useCallback(
    (row, order) => {
      // dispatch(actionSetPageSideEffects(1));
      dispatch(
        actionFetchSideEffects(
          1,
          { row, order },
          {
            query: query,
            query_data: queryData,
          }
        )
      );
    },
    [query, queryData]
  );
  const handleEdit = useCallback(
    (data) => {
      setEditData(data);
      setSidePanel((e) => !e);
    },
    [setEditData, setSidePanel]
  );
  const handleEditSidePannel = useCallback(
    (data) => {
      setSidePanel((e) => !e);
      if (data) {
        setEditData(data);
      } else {
        setEditData(null);
      }
    },
    [setSidePanel, setEditData]
  );

  const handleDetail = useCallback((type) => {
    history.push(`${RouteName.REPORTED_DETAIL}${type?.id}`);
  }, []);


  const configFilter = useMemo(() => {
    return [
      {
        label: "Client",
        name: "client_id",
        type: "selectObject",
        custom: { extract: { id: "id", title: "name" } },
        fields: listData?.CLIENTS,
        // fields: listData?.CLIENTS?.map((client) => ({
        //   label: client.name, 
        //   value: client.id,   
        // })),
      },
      {
        label: "Program",
        name: "program_id",
        type: "selectObject",
        custom: { extract: { id: "id", title: "name" } },
        fields:  listData?.PROGRAMS,
        
        // fields: listData?.PROGRAMS?.map((program) => ({
        //   label: program.name, 
        //   value: program.id,   
        // })),
      },
    ];
  }, [listData]);

console.log(data, "Data:")

  const handleExport = useCallback(()=> {
    setIsSubmitting(true);
    serviceExportSideEffects({
      index: 1,
      row: sortingData?.row,
      order: sortingData?.order,
      query: query,
      query_data: queryData,
    }).then((res) => {
      if (!res.error) {
        const data = res.data;
        window.open(data, "_blank");
      }
      setIsSubmitting(false);
    });
  }, [sortingData, query, queryData]);


  return {
    handlePageChange,
    handleFilterDataChange,
    handleSearchValueChange,
    handleSortOrderChange,
    handleEdit,
    isSidePanel,
    editData,
    configFilter,
    handleEditSidePannel,
    handleDetail,
    handleExport,
    isSubmitting
  };
};

export default useReportedSideEffectsListHook;
